import { render, staticRenderFns } from "./SectionNews.component.vue?vue&type=template&id=297c11f6&"
import script from "./SectionNews.component.vue?vue&type=script&lang=js&"
export * from "./SectionNews.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports